import {Input} from "@/components/ui/input.tsx";
import {ComponentProps} from "react";

export default function NumberInput(props: ComponentProps<typeof Input>) {
    return <Input inputMode="numeric" type="number" {...props} />;
}
